export default __webpack_public_path__ + "static/media/FeverPoles_02.bbae5103.png";